import { ViewDecoratorType } from '@baserow/modules/database/viewDecorators'
import {
  GalleryViewType,
  GridViewType,
} from '@baserow/modules/database/viewTypes'

import {
  CalendarioMGViewType,
  KanbanMGViewType,
  TimelineMGViewType,
} from '@extras_mg/viewTypes'

import BordeIzquierdoColor from '@extras_mg/components/BordeIzquierdoColor'
import FondoColor from '@extras_mg/components/FondoColor'

/**
 * Coloreado de filas. La infraestructura entera (modelo ViewDecoration, los
 * registros, el menu, y el paso de decorations-by-place a la cuadricula) es del
 * core y es MIT; esto solo aporta los dos tipos concretos que Baserow reserva a
 * su edicion de pago.
 *
 * Llevan los MISMOS nombres de tipo que los de premium y reemplazan su
 * registro. Dos razones:
 *
 * 1. Si conviven, el menu "Add decorator" muestra cuatro entradas: las dos de
 *    premium con candado y las dos nuestras. El usuario hace clic en la
 *    primera y topa con el paywall. Es lo mismo que pasaba con la pestana de
 *    comentarios.
 * 2. La configuracion guardada es compatible, asi que cualquier decoracion que
 *    ya exista con esos tipos empieza a pintar. Hoy las unicas son las de las
 *    plantillas que Baserow trae de fabrica (729); el workspace real no tiene
 *    ninguna todavia.
 */

/**
 * Las vistas donde se puede colorear.
 *
 * Ademas de la cuadricula y la galeria del core van las tres nuestras: sus
 * tipos ya declaran can_decorate en el backend y sus componentes pintan el
 * color (la tarjeta del Kanban por RowCard, el calendario con un punto y la
 * linea de tiempo en la barra). Sin esta lista el boton "Color" ni siquiera
 * aparecia en su cabecera, asi que la decoracion no se podia configurar.
 */
const TIPOS_CON_COLOR = [
  GridViewType.getType(),
  GalleryViewType.getType(),
  KanbanMGViewType.getType(),
  CalendarioMGViewType.getType(),
  TimelineMGViewType.getType(),
]

class ColorViewDecoratorType extends ViewDecoratorType {
  isCompatible(view) {
    return TIPOS_CON_COLOR.includes(view.type)
  }

  isDeactivated() {
    // Nunca. El de premium devuelve true sin licencia y por eso solo pinta el
    // anuncio; este es nuestro y funciona siempre.
    return false
  }

  canAdd({ view }) {
    // Dos decoradores del mismo tipo en la misma vista se pisarian.
    const yaEsta = view.decorations.some((d) => d.type === this.getType())
    return yaEsta
      ? [false, 'Esta vista ya tiene este decorador.']
      : [true, '']
  }
}

export class BordeIzquierdoColorViewDecoratorType extends ColorViewDecoratorType {
  static getType() {
    return 'left_border_color'
  }

  getName() {
    return 'Barra de color a la izquierda'
  }

  getDescription() {
    return 'Pinta una barra de color al inicio de cada fila.'
  }

  getPlace() {
    return 'first_cell'
  }

  getComponent() {
    return BordeIzquierdoColor
  }
}

export class FondoColorViewDecoratorType extends ColorViewDecoratorType {
  static getType() {
    return 'background_color'
  }

  getName() {
    return 'Fondo de color'
  }

  getDescription() {
    return 'Pinta el fondo completo de cada fila.'
  }

  getPlace() {
    return 'wrapper'
  }

  getComponent() {
    return FondoColor
  }
}
